import { useState } from 'react';
import type { Site, SiteTemplate } from '../../schemas/validation';

export interface DashboardState {
  sites: Site[];
  setSites: React.Dispatch<React.SetStateAction<Site[]>>;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  isCreating: boolean;
  setIsCreating: (creating: boolean) => void;
  newSiteName: string;
  setNewSiteName: (name: string) => void;
  selectedTheme: string;
  setSelectedTheme: (theme: string) => void;
  showCreateForm: boolean;
  setShowCreateForm: (show: boolean) => void;
  useTemplate: boolean;
  setUseTemplate: (use: boolean) => void;
  selectedTemplate: SiteTemplate | null;
  setSelectedTemplate: (template: SiteTemplate | null) => void;
  showTemplateLibrary: boolean;
  setShowTemplateLibrary: (show: boolean) => void;
  showSuccessToast: boolean;
  setShowSuccessToast: (show: boolean) => void;
  successMessage: string;
  setSuccessMessage: (message: string) => void;
  showDeleteModal: boolean;
  setShowDeleteModal: (show: boolean) => void;
  siteToDelete: Site | null;
  setSiteToDelete: (site: Site | null) => void;
  isDeleting: boolean;
  setIsDeleting: (deleting: boolean) => void;
  deleteError: string | null;
  setDeleteError: (error: string | null) => void;
  currentPlan: any;
  setCurrentPlan: (plan: any) => void;
  subscriptionStatus: any;
  setSubscriptionStatus: (status: any) => void;
  createError: string | null;
  setCreateError: (error: string | null) => void;
}

export const useDashboardState = (): DashboardState => {
  const [sites, setSites] = useState<Site[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCreating, setIsCreating] = useState(false);
  const [newSiteName, setNewSiteName] = useState('');
  const [selectedTheme, setSelectedTheme] = useState('standard');
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [useTemplate, setUseTemplate] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<SiteTemplate | null>(null);
  const [showTemplateLibrary, setShowTemplateLibrary] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [siteToDelete, setSiteToDelete] = useState<Site | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState<string | null>(null);
  const [currentPlan, setCurrentPlan] = useState<any>(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState<any>(null);
  const [createError, setCreateError] = useState<string | null>(null);

  return {
    sites,
    setSites,
    isLoading,
    setIsLoading,
    isCreating,
    setIsCreating,
    newSiteName,
    setNewSiteName,
    selectedTheme,
    setSelectedTheme,
    showCreateForm,
    setShowCreateForm,
    useTemplate,
    setUseTemplate,
    selectedTemplate,
    setSelectedTemplate,
    showTemplateLibrary,
    setShowTemplateLibrary,
    showSuccessToast,
    setShowSuccessToast,
    successMessage,
    setSuccessMessage,
    showDeleteModal,
    setShowDeleteModal,
    siteToDelete,
    setSiteToDelete,
    isDeleting,
    setIsDeleting,
    deleteError,
    setDeleteError,
    currentPlan,
    setCurrentPlan,
    subscriptionStatus,
    setSubscriptionStatus,
    createError,
    setCreateError,
  };
};
